/**
 * Vocabulaire adapté au type de projet.
 *
 * Pour `apartment_single`, "Bâtiment / Étage / Lot" devient
 * "Appartement / Niveau / Pièce" — plus naturel pour un bien existant.
 * Pour tous les autres types (promotion neuve / résidence / etc.) on garde
 * le vocabulaire promoteur classique.
 */
export function getProjectVocab(projectTypeCode) {
  if (projectTypeCode === 'apartment_single') {
    return {
      building:        'Appartement',
      buildings:       'Appartement',
      buildingShort:   'Apt.',
      floor:           'Niveau',
      floors:          'Niveaux',
      floorShort:      'Niveau',
      lot:             'Pièce',
      lots:            'Pièces',
      lotShort:        'Pièce',
      addBuilding:     'Définir l\'appartement',
      addFloor:        'Ajouter un niveau',
      addLot:          'Ajouter une pièce',
      noBuildings:     'Aucun appartement configuré',
      noLots:          'Aucune pièce définie',
      hierarchyHint:   'Définissez chaque pièce (salon, chambre…) avec son style et ses matériaux.',
    };
  }
  return {
    building:        'Bâtiment',
    buildings:       'Bâtiments',
    buildingShort:   'Bât.',
    floor:           'Étage',
    floors:          'Étages',
    floorShort:      'Étage',
    lot:             'Lot',
    lots:            'Lots',
    lotShort:        'Lot',
    addBuilding:     'Créer un bâtiment',
    addFloor:        'Ajouter un étage',
    addLot:          'Ajouter un lot',
    noBuildings:     'Aucun bâtiment',
    noLots:          'Aucun lot',
    hierarchyHint:   'Découpez votre projet en bâtiments → étages → lots.',
  };
}
